import { Injectable } from "@angular/core";
import { BaseApiService } from "@app/api/base_api";
import { Vendor } from "../types";

@Injectable()
export class VendorService extends BaseApiService<Vendor> {
  component: string = "vendor";
}
